module.exports = __webpack_public_path__ + "static/media/image 10.e4620d5a.png";